import script from "./Footer.vue?vue&type=script&lang=ts&setup=true"
export * from "./Footer.vue?vue&type=script&lang=ts&setup=true"

import "./Footer.vue?vue&type=style&index=0&id=89a2029c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89a2029c"]])

export default __exports__